const baseConfig = {
  // baseDomain: "",
  baseDomain: "",
  imgbaseUrl: "",
  phoneRegRex: /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/,
  maxUploadSize: 1
};

export default baseConfig;



// WEBPACK FOOTER //
// ./src/utils/config.js